module.exports = __webpack_public_path__ + "static/img_0883-1040cd0e38645954da9c559c4ca73bdd.webp";